/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import * as follow_tags from '@fof-follow-tags';
import FollowingFilterDropdown from '../components/FollowingFilterDropdown';
import IndexPageHero from 'flarum/newvigation/components/IndexPageHero';
import type ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

/**
 * `Page.bodyClass` is `protected`, so it is not reachable through the `this` type
 * `extend` hands to its callback.
 */
export interface PageBodyClass {
	bodyClass: string;
}

export default function () {
	if (app.initializers.has('fof/follow-tags')) {
		extend(IndexPage.prototype, 'oninit', function () {
			if (!follow_tags.utils.isFollowingPage() || !app.session.user) return;
			(this as unknown as PageBodyClass).bodyClass = 'App--index App--following';
		});

		extend(IndexPage.prototype, 'sidebarItems', function (items) {
			if (!follow_tags.utils.isFollowingPage() || !app.session.user) return;

			// Empty the item set: we will add only new elements and don't want any old ones
			items.toArray().forEach(({ itemName }) => (itemName === 'newDiscussion' ? null : items.remove(itemName)));

			items.add('title', <h3>{app.translator.trans('glowingblue-orell-thalia-common.forum.index.following_title_filter')}</h3>, 150);

			items.add('filter', <FollowingFilterDropdown />);
		});

		if (app.initializers.has('glowingblue-newvigation')) {
			extend(IndexPageHero.prototype, 'items', function (items: ItemList<Mithril.Children>) {
				if (!follow_tags.utils.isFollowingPage() || !app.session.user) return;
				items.add('filter', <FollowingFilterDropdown />);
			});
		}
	}
}
